import { render, staticRenderFns } from "./Participant.vue?vue&type=template&id=184f92c8&"
import script from "./Participant.vue?vue&type=script&lang=js&"
export * from "./Participant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\RobertWiberg\\source\\repos\\server-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('184f92c8')) {
      api.createRecord('184f92c8', component.options)
    } else {
      api.reload('184f92c8', component.options)
    }
    module.hot.accept("./Participant.vue?vue&type=template&id=184f92c8&", function () {
      api.rerender('184f92c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/View/Recipients/Participant.vue"
export default component.exports